StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'

class exports.CheckboxesHandler extends StepHandler

    inputSel: 'button.spp-checkbox'

    addValidationRules: () =>
        @validator.registerRule
            selector: '.validate-checkbox'
            text: 'Please select one or more options'
            func: (elem) =>
                return (!!@getInputEl().filter('.active').length)

        $('.validationContainer').undelegate '.validate-checkbox', 'change'


    getFieldAspect: (fieldID, aspectID) =>
        retval =
            value: @getInputEl(aspect: aspectID).is(':enabled.active')

        return retval

    setFieldAspect: (fieldAspect) =>
        input = @getInputEl
            aspect: fieldAspect.aspects_id

        if fieldAspect.value and input.is(':enabled')
            input.addClass('active')
        else
            input.removeClass('active')


    afterLoadLayout: (sel, data) =>
        super(sel, data)
        # step = this

        @getInputEl().on 'click', () ->
            el = $(this)

            # This is to make sure that we don't fire the change event or call
            # _updateSelectAllButton after the click event handlers finish.
            # The button's "active" class will not be updated otherwise.

            # Basically this is because Bootstrap uses the .delegate method to
            # attach the click event handler that updates the "active" class.
            # With jQuery, any event handlers attached with .delegate are
            # called after those attached with .on, .bind, or .click.
            setTimeout () ->
                el.change()
                # step._updateSelectAllButton()

        ###
        I'm commenting this out for now because I don't think it's useful, but
        if anyone complains, then we can easily add it back. If it turns out
        nobody cares, then we should remove the button HTML from the view too.
        ###
        # Select All button interaction
        # selectAll = $(@parent.layoutSelector).find('#select_all_button')
        # selectAll.on 'click', () ->
        #     if selectAll.hasClass('active')
        #         step.getInputEl().filter('.active').click()
        #     else
        #         step.getInputEl().filter(':not([disabled],.active)').click()

        # # initialize the button
        # @_updateSelectAllButton()

    # _updateSelectAllButton: () =>
    #     selectAll = $(@parent.layoutSelector).find('#select_all_button')

    #     if @getInputEl().filter(':not([disabled],.active)').length is 0
    #         selectAll.text('Deselect All').addClass('active')
    #     else
    #         selectAll.text('Select All').removeClass('active')
